import axios from 'axios'
import { routesAnalyticsRegister } from '../routes'
import { CANCEL,
    REQUEST_PHONE_CODES,
    REQUEST_PHONE_CODES_SUCCESS,
    REQUEST_PHONE_CODES_ERROR,
    REQUEST_RECAPTCHA,
    REQUEST_RECAPTCHA_SUCCESS,
    REQUEST_RECAPTCHA_ERROR,
    SUBMIT_REQUEST,
    SUBMIT_REQUEST_SUCCESS,
    SUBMIT_REQUEST_ERROR,
    SESSION_TIMEOUT } from '../constants/analytics-register'
import { isSessionTimedOut } from '../utils/app-context'


export const sessionTimeout = () => ({ type: SESSION_TIMEOUT })

export const cancel = payload => ({ payload, type: CANCEL })

export const onSubmitRequest = () => ({ type: SUBMIT_REQUEST })
export const onSubmitRequestFailure = payload => ({ payload, type: SUBMIT_REQUEST_ERROR })
export const onSubmitRequestSuccess = payload => ({ payload, type: SUBMIT_REQUEST_SUCCESS })

export const onRequestReCaptcha = () => ({ type: REQUEST_RECAPTCHA })
export const onRequestReCaptchaFailure = payload => ({ payload, type: REQUEST_RECAPTCHA_ERROR })
export const onRequestReCaptchaSuccess = payload => ({ payload, type: REQUEST_RECAPTCHA_SUCCESS })

export const onRequestPhoneCodes = () => ({ type: REQUEST_PHONE_CODES })
export const onRequestPhoneCodesFailure = payload => ({ payload, type: REQUEST_PHONE_CODES_ERROR })
export const onRequestPhoneCodesSuccess = payload => ({ payload, type: REQUEST_PHONE_CODES_SUCCESS })


export const submitRequest = values => {
    return dispatch => {
        dispatch(onSubmitRequest())
        axios.post(routesAnalyticsRegister.submitRequest, values)
            .then(() => dispatch(onSubmitRequestSuccess()))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout)
                }
                dispatch(onSubmitRequestFailure(err.response.data.error))
            })
    }
}

export const requestRecaptcha = values => {
    return dispatch => {
        dispatch(onRequestReCaptcha())
        axios.get(routesAnalyticsRegister.requestRecaptcha)
            .then(result => dispatch(onRequestReCaptchaSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout)
                }
                dispatch(onRequestReCaptchaFailure(err.response.data.error))
            })
    }
}

export const requestPhoneCodes = () => {
    return dispatch => {
        dispatch(onRequestPhoneCodes())
        axios.get(routesAnalyticsRegister.requestPhoneCodes)
            .then(result => dispatch(onRequestPhoneCodesSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout)
                }
                dispatch(onRequestPhoneCodesFailure(err.response.data.error))
            })
    }
}

